import { render, staticRenderFns } from "./Dtu.vue?vue&type=template&id=1181ba6d&scoped=true"
import script from "./Dtu.vue?vue&type=script&lang=js"
export * from "./Dtu.vue?vue&type=script&lang=js"
import style0 from "./Dtu.vue?vue&type=style&index=0&id=1181ba6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181ba6d",
  null
  
)

export default component.exports